// 
import WebComponent from '../src/webComponents/WebComponent';
import * as CursorSpinner from '../src/components/CursorSpinner';

export default class EshopGalleryPopup extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	didMount() {
		this.on('click', this.handleClick);
	}
	handleClick(e) {
		const {
			item,
		} = this.props;
		let puUrl = '@gallery?ramJetLayoutContext=galleryPopup';
    const replaceImageSourceThumb = this.element.getAttribute('data-replace-image-source-thumb');
    const replaceImageSourceThumbX2 = this.element.getAttribute('data-replace-image-source-thumb-x2');
    const replaceImageSourceThumbWebp = this.element.getAttribute('data-replace-image-source-thumb-webp');
    const replaceImageSourceThumbX2Webp = this.element.getAttribute('data-replace-image-source-thumb-x2-webp');
    const replaceImageSourceFull = this.element.getAttribute('data-replace-image-source-full');
    const replaceImageSourceFullX2 = this.element.getAttribute('data-replace-image-source-full-x2');
    const replaceImageSourceFullWebp = this.element.getAttribute('data-replace-image-source-full-webp');
    const replaceImageSourceFullX2Webp = this.element.getAttribute('data-replace-image-source-full-x2-webp');

    puUrl += `&activeItem=${item}`;

    if (replaceImageSourceThumb) {
      puUrl += `&replaceImageSourceThumb=${replaceImageSourceThumb}`;
    }
    if (replaceImageSourceThumbX2) {
      puUrl += `&replaceImageSourceThumbX2=${replaceImageSourceThumbX2}`;
    }
    if (replaceImageSourceThumbWebp) {
      puUrl += `&replaceImageSourceThumbWebp=${replaceImageSourceThumbWebp}`;
    }
    if (replaceImageSourceThumbX2Webp) {
      puUrl += `&replaceImageSourceThumbX2Webp=${replaceImageSourceThumbX2Webp}`;
    }

    if (replaceImageSourceFull) {
      puUrl += `&replaceImageSourceFull=${replaceImageSourceFull}`;
    }
    if (replaceImageSourceFullX2) {
      puUrl += `&replaceImageSourceFullX2=${replaceImageSourceFullX2}`;
    }
    if (replaceImageSourceFullWebp) {
      puUrl += `&replaceImageSourceFullWebp=${replaceImageSourceFullWebp}`;
    }
    if (replaceImageSourceFullX2Webp) {
      puUrl += `&replaceImageSourceFullX2Webp=${replaceImageSourceFullX2Webp}`;
    }

    e.preventDefault();
		CursorSpinner.pushToQueue('showEshopGalleryPopup');

		let targetUrl = window.location.href;
		if (targetUrl.indexOf('#') != -1) {
		  const splitUrl = targetUrl.split('#');
		  targetUrl = splitUrl[0];
    }

		if (targetUrl.indexOf('?') === -1) {
			targetUrl += puUrl;
		} else {
			targetUrl = targetUrl.replace('?', `${puUrl}&`);
		}

    const xhr = new XMLHttpRequest();
    xhr.open('GET', targetUrl);
    xhr.send(null);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        if (xhr.status == 200) {
          CursorSpinner.removeFromQueue('showEshopGalleryPopup');
          edeeshopPopup.createPopup(xhr.responseText, 'esp__target--gallery esp-eshop-gallery');
        }
      }
    };
	};
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/EshopGalleryPopup.js